module.exports = __webpack_public_path__ + "img/商品详情-2.a9c370ba.png";